<template>
  <div class="bi-Bread_box">
    <div class="bi-Bread_back" @click="handleBack">
      <i class="el-icon-back"></i>
      返回
    </div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-for="(item, index) in titles" :key="index">{{
        item
      }}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    titles: {
      type: Array,
      default: () => [],
    },
    showBack: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleBack() {
      if (this.showBack) {
        this.$router.back();
      }
      this.$emit("back");
    },
  },
};
</script>

<style scoped lang="scss">
.bi-Bread_box {
  display: flex;
  align-items: center;
	padding-bottom: 14px;
	border-bottom: 1px solid #EDEDED;
  .bi-Bread_back {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #3159ff;
    margin-right: 12px;
		font-weight: bold;
  }
  ::v-deep .el-breadcrumb__item {
    .el-breadcrumb__inner {
      color: #999;
    }
    .el-breadcrumb__separator {
      color: #999;
      margin: 0 4px;
      font-weight: normal;
    }
  }
  ::v-deep .el-breadcrumb__item:last-child {
    .el-breadcrumb__inner {
      color: #333333;
    }
  }
}
</style>
